/**
 *
 * IncreaseBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import ArrowSecondaryTopRightIcon from '../../../../assets/v2/ArrowSecondaryTopRightIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.green};
    background: ${COLORS.greenLight};
    border-color: ${COLORS.green};
    border-width: 0.5px;
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.green};
    }
  }
`;

function IncreaseBadge(props) {
  return <StyledBadge endIcon={<ArrowSecondaryTopRightIcon />} {...props} />;
}

export default memo(IncreaseBadge);
